export default __webpack_public_path__ + "static/media/challengesIcon.8b6ebc8e.svg";